jQuery(".posts_carousel_slider").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  dots: true,
  speed: 1000,
  autoplay: true,
  autoplaySpeed: 2000,
  centerMode: true,
  centerPadding: "200px",
  arrows: false,
  accessibility: false,
  responsive: [
    // {
    //   breakpoint: 1200,
    //   settings: {
    //     slidesToShow: 2,
    //     slidesToScroll: 2,
    //     centerPadding: "100px"
    //   }
    // },
    // {
    //   breakpoint: 1024,
    //   settings: {
    //     slidesToShow: 2,
    //     slidesToScroll: 2,
    //     centerPadding: "70px"
    //   }
    // },
    // {
    //   breakpoint: 768,
    //   settings: {
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     centerPadding: "60px"
    //   }
    // }
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        centerPadding: "100px"
      }
    },
    {
      breakpoint: 1599,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        centerPadding: "70px"
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: "60px"
      }
    }
  ]
});


jQuery(".featuredSlick").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  speed: 1500,
  autoplay: true,
  autoplaySpeed: 5000,
  // centerMode: true,
  // centerPadding: "200px",
  arrows: false,
  accessibility: false,
  mobileFirst: true,
  responsive: [{
      breakpoint: 1023,
      settings: "unslick"
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
      slidesToScroll: 2
      }
      
    }
  ]
});



jQuery(window).on('load', () => {
  const element = jQuery('.featuredSlick');
  const mediaQuery = window.matchMedia('(max-width: 1023px)');

  const handleSwitchSlick = ((e) => {
    if (e.matches) {
      element.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        speed: 1500,
        autoplay: true,
        autoplaySpeed: 5000,
        // centerMode: true,
        // centerPadding: "200px",
        arrows: false,
        accessibility: false,
        mobileFirst: true,
      });
    } else if (element.hasClass('slick-initialized')) {
      element.slick('unslick');
    }
  });

  mediaQuery.addListener(handleSwitchSlick);
  handleSwitchSlick(mediaQuery);
});